"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toNumber = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _activeElement = _interopRequireDefault(require("dom-helpers/activeElement"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _useControlled3 = _interopRequireDefault(require("../../Hook/useControlled"));
var _omit = _interopRequireDefault(require("ramda/src/omit"));
var _ref2 = require("../../utils/ref");
var _excluded = ["defaultValue", "value", "autoComplete", "disabled", "displayErrors", "embedded", "format", "hasError", "hasRequired", "hasSuccess", "readOnly", "required", "className", "customValidityPattern", "hasValidation", "inputClassName", "inputRef", "name", "onBlur", "onChange", "onFocus", "onWheel", "placeholder", "ref", "setDisplayErrorsState", "setLoadingState", "theme", "title", "type"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable react/display-name */ /*:: import type { ThemeType } from '../../style/ThemeTypes';*/
/*:: type NumberValue = '' | number;*/
/*:: export type NumberInputProps = {
  autoComplete?: string,
  children?: React.Node,
  displayErrors?: boolean,
  embedded?: boolean,
  // Presentational Intl format options object
  format?: Object,
  hasError?: boolean,
  hasRequired?: boolean,
  hasSuccess?: boolean,
  hasValidation?: boolean,
  inputClassName?: string,
  inputRef?: React.ElementRef<*>,
  disabled?: boolean,
  readOnly?: boolean,
  onBlur?: ({
    currentTarget: { id: string, name: string, value: NumberValue }
  }) => mixed,
  onChange?: ({
    currentTarget: { id: string, name: string, value: NumberValue }
  }) => mixed,
  onFocus?: ({
    currentTarget: { id: string, name: string, value: NumberValue }
  }) => mixed,
  onWheel?: ({
    currentTarget: { id: string, name: string, value: NumberValue }
  }) => mixed,
  setDisplayErrorsState?: (displayErrors: boolean) => mixed,
  setLoadingState?: (loading: boolean) => mixed
};*/
/*:: export type NumberInputType = $Diff<HTMLInputElement, NumberInputProps> &
  NumberInputProps;*/
var toNumber = exports.toNumber = function toNumber(value /*: string*/) /*: NumberValue*/{
  return value === '' ? value : Number(value);
};
var toEventShape = function toEventShape(event /*: SyntheticEvent<HTMLInputElement>*/, props /*: Object*/) {
  return {
    currentTarget: {
      id: props.id,
      name: props.name,
      value: toNumber(event.currentTarget.value)
    }
  };
};
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  var editInput = _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.truncate), {}, {
    '&:required:invalid': {
      paddingRight: theme.variables.inputRequiredPaddingRight
    },
    '&:focus:required:invalid, &:required:valid': _objectSpread(_objectSpread({}, theme.mixins.inputPadding), {}, {
      '& ~ $required': {
        display: 'none'
      }
    }),
    /// https://css-tricks.com/numeric-inputs-a-comparison-of-browser-defaults/
    // Remove controls from Safari and Chrome
    '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0 // Removes leftover margin
    },
    // Remove controls from Firefox
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    readOnly: {
      '&[readonly]': {
        '&, &:focus, &:hover': theme.mixins.inputReadOnly
      }
    },
    disabled: {
      '&:disabled': {
        '&, &:focus, &:hover': theme.mixins.inputDisabled
      }
    }
  });
  var viewInput = (0, _omit.default)(['&[readonly]'])(editInput);
  return {
    root: {
      position: 'relative'
    },
    hidden: {
      display: 'none'
    },
    editInput: editInput,
    viewInput: viewInput,
    displayErrors: {
      '&:valid': theme.mixins.inputSuccess,
      '&:invalid': theme.mixins.inputError
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    required: {}
  };
});
var NumberInput = function NumberInput(_ref /*:: */) {
  var defaultValue = _ref /*:: */.defaultValue,
    valueProp = _ref /*:: */.value,
    _ref$autoComplete = _ref /*:: */.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    _ref$disabled = _ref /*:: */.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$displayErrors = _ref /*:: */.displayErrors,
    displayErrors = _ref$displayErrors === void 0 ? false : _ref$displayErrors,
    _ref$embedded = _ref /*:: */.embedded,
    embedded = _ref$embedded === void 0 ? false : _ref$embedded,
    _ref$format = _ref /*:: */.format,
    format = _ref$format === void 0 ? null : _ref$format,
    _ref$hasError = _ref /*:: */.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$hasRequired = _ref /*:: */.hasRequired,
    hasRequired = _ref$hasRequired === void 0 ? true : _ref$hasRequired,
    _ref$hasSuccess = _ref /*:: */.hasSuccess,
    hasSuccess = _ref$hasSuccess === void 0 ? false : _ref$hasSuccess,
    _ref$readOnly = _ref /*:: */.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$required = _ref /*:: */.required,
    required = _ref$required === void 0 ? false : _ref$required,
    className = _ref /*:: */.className,
    customValidityPattern = _ref /*:: */.customValidityPattern,
    hasValidation = _ref /*:: */.hasValidation,
    inputClassNameProp = _ref /*:: */.inputClassName,
    inputRefProp = _ref /*:: */.inputRef,
    name = _ref /*:: */.name,
    onBlur = _ref /*:: */.onBlur,
    onChange = _ref /*:: */.onChange,
    onFocus = _ref /*:: */.onFocus,
    onWheel = _ref /*:: */.onWheel,
    placeholder = _ref /*:: */.placeholder,
    unusedRefProp = _ref /*:: */.ref,
    setDisplayErrorsState = _ref /*:: */.setDisplayErrorsState,
    setLoadingState = _ref /*:: */.setLoadingState,
    theme = _ref /*:: */.theme,
    title = _ref /*:: */.title,
    type = _ref /*:: */.type,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  /*
   * State Managment
   */
  var _React$useState = React.useState('viewing'),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    userIntent = _React$useState2[0],
    setUserIntent = _React$useState2[1];
  var _useControlled = (0, _useControlled3.default)({
      value: valueProp,
      defaultValue: defaultValue,
      name: 'NumberInput'
    }),
    _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
    value = _useControlled2[0],
    setValueIfUncontrolled = _useControlled2[1];

  /*
   * Style and Intl
   */
  var intl = (0, _reactIntl.useIntl)();
  var classes = useStyles();
  var editInputClassName = (0, _classnames.default)(classes.editInput, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.displayErrors, displayErrors), classes.error, hasError), classes.success, hasSuccess), classes.disabled, disabled), classes.readOnly, readOnly), inputClassNameProp);
  var viewInputClassName = (0, _classnames.default)(classes.viewInput, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.displayErrors, displayErrors), classes.error, hasError), classes.success, hasSuccess), classes.disabled, disabled), classes.readOnly, readOnly), inputClassNameProp);

  /*
   * Event Handlers
   */
  var handleBlur = React.useCallback(function (event /*: SyntheticEvent<HTMLInputElement>*/) {
    setUserIntent('viewing');
    if (typeof onBlur === 'function') onBlur(toEventShape(event, {
      id: props.id,
      name: name
    }));
  }, [onBlur, props.id, name]);
  var handleFocus = React.useCallback(function (event /*: SyntheticEvent<HTMLInputElement>*/) {
    if (!readOnly) setUserIntent('editing');
    if (typeof onFocus === 'function') onFocus(toEventShape(event, {
      id: props.id,
      name: name
    }));
  }, [onFocus, props.id, name, readOnly]);
  var handleChange = React.useCallback(function (event /*: SyntheticEvent<HTMLInputElement>*/) {
    setValueIfUncontrolled(event.currentTarget.value);
    if (typeof onChange === 'function') onChange(toEventShape(event, {
      id: props.id,
      name: name
    }));
  }, [onChange, setValueIfUncontrolled, props.id, name]);
  var handleWheel = React.useCallback(function (event /*: SyntheticEvent<HTMLInputElement>*/) {
    if (event.currentTarget === (0, _activeElement.default)()) {
      event.currentTarget.blur();
    }
    if (typeof onWheel === 'function') {
      return onWheel(toEventShape(event, {
        id: props.id,
        name: name
      }));
    }
  }, [onWheel, props.id, name]);

  /*
   * Effects
   */
  var editInputRef = React.useCallback(function (editInput) {
    if (userIntent === 'editing' && editInput != null && editInput !== (0, _activeElement.default)()) editInput.focus();
  }, [userIntent]);
  var ref = (0, _ref2.useForkedRef)(inputRefProp, editInputRef);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    title: title
  }, /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
    autoComplete: autoComplete,
    ref: ref,
    className: (0, _classnames.default)(editInputClassName, (0, _defineProperty2.default)({}, classes.hidden, userIntent !== 'editing')),
    "data-name": name,
    "data-testid": "number-input",
    disabled: disabled || readOnly,
    key: "edit",
    onBlur: handleBlur,
    onChange: handleChange,
    onWheel: handleWheel,
    placeholder: placeholder,
    type: "number",
    value: value !== null && value !== void 0 ? value : '',
    name: name,
    readOnly: readOnly,
    required: required
  }, props)), userIntent === 'viewing' && /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: viewInputClassName,
    readOnly: readOnly,
    disabled: disabled,
    onFocus: handleFocus,
    key: "view",
    placeholder: placeholder,
    defaultValue: typeof value === 'string' && value.length > 0 || typeof value === 'number' ? format != null && Object.keys(format).length > 0 ? intl.formatNumber(Number(value), format) : value : '',
    required: required
  }), /*#__PURE__*/React.createElement(_InputRequired.default, {
    className: classes.required,
    disabled: disabled,
    embedded: embedded,
    hasRequired: hasRequired,
    readOnly: readOnly,
    required: required
  }));
};
var _default = exports.default = NumberInput;
//# sourceMappingURL=NumberInput.js.map